import { render, staticRenderFns } from "./Ushers.vue?vue&type=template&id=3beb699a&lang=pug&"
import script from "./Ushers.vue?vue&type=script&lang=js&"
export * from "./Ushers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports